/**
 * APIMATIC CalculatorLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { passThroughInterceptor } from './core';

/** None authentication provider */
export const noneAuthenticationProvider = () => passThroughInterceptor;
